import React, { Component } from 'react';
import { Typography, Icon } from 'rmwc';
export class ExpandableGroup extends Component {
  constructor(props) {
    super(props);
    if (props.openIndex || props.openIndex === 0) {
      this.state = { open: props.openIndex };
    } else {
      this.state = { open: -1 };
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.openIndex != nextProps.openIndex) {
      this.setState({ open: nextProps.openIndex });
    }
  }
  onClick = item => {
    if (this.state.open == item) {
      this.setState({
        open: -1,
      });
    } else {
      this.setState({
        open: item,
      });
    }
  };
  render() {
    const { children, style, titleStyle } = this.props;
    const { open } = this.state;
    return (
      <div style={style}>
        {React.Children.map(children, (child, i) => {
          return React.cloneElement(child, {
            key: i,
            open: i == open,
            titleStyle: titleStyle,
            onClick: () => this.onClick(i),
          });
        })}
      </div>
    );
  }
}

export const ExpandableItem = ({
  title,
  open,
  onClick,
  children,
  style = {},
  wrapperStyle = {},
  contentStyle = {},
  titleStyle = 'body1',
}) => (
  <div style={Object.assign({ borderBottom: '1px solid #EEEEEE' }, wrapperStyle)}>
    <div
      className="fake-ripple"
      style={Object.assign(
        {
          display: 'flex',
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.5rem',
        },
        style
      )}
      onClick={onClick}
    >
      <Typography use={titleStyle}>{title}</Typography>
      <Icon theme="text-secondary-on-background">{open ? 'expand_less' : 'add'}</Icon>
    </div>
    {open && (
      <div style={Object.assign({ borderTop: '1px solid #EEEEEE', padding: '0.5rem 0' }, contentStyle)}>{children}</div>
    )}
  </div>
);
